import { Grid, LinearProgress } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import clsx from 'clsx'
import React from 'react'
import { LimitChangeRow } from 'src/modules/admin/group-manager/gm_scopes'
import { DateFns } from 'src/utils/date-fns'
import { ProfileScope } from '../../gp_scopes'
import ProfileCard from './profile-card'

const rowsPerPageOptions = [10, 25, 50, 75, 100, 500]

export type LimitChangedHistoryTableProps = {
    className?: string
    style?: React.CSSProperties
    key?: string
    scope: ProfileScope
}

function LimitChangedHistoryTable({ scope, className, style }: LimitChangedHistoryTableProps) {
    const history = scope.profile?.limitHistory || ([] as LimitChangeRow[])
    const columns = static_build_history_columns()

    return (
        <ProfileCard caption="Histórico de alteração de franquia contratada" className={clsx(className)} style={style}>
            <Grid container spacing={2}>
                <Grid size={{ sm: 12 }} sx={{ height: 594 }}>
                    <DataGrid
                        rows={history}
                        columns={columns}
                        getRowId={static_getRowId}
                        disableColumnSelector
                        pageSizeOptions={rowsPerPageOptions}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10
                                }
                            }
                        }}
                    />
                    {scope.waiting && <LinearProgress color="secondary" />}
                </Grid>
            </Grid>
        </ProfileCard>
    )
}
export default LimitChangedHistoryTable

function static_build_history_columns(): GridColDef[] {
    return [
        {
            field: 'data_hora',
            headerName: 'Data da Alteração',
            width: 200,
            align: 'center',
            headerAlign: 'center',
            valueFormatter: (value) => DateFns.formatDate(value, 'dd/MM/yyyy HH:mm')
        },
        {
            field: 'new_limit_export',
            headerName: 'Nova Franquia Contratada',
            align: 'right',
            headerAlign: 'right',
            width: 300,
            renderCell: (params) => <span>{params.row.unlimited_data_export ? 'ILIMITADA' : params.value}</span>
        }
    ]
}

function static_getRowId(row: LimitChangeRow) {
    return row.seq + ''
}
